import Vue from 'vue'
import Router from 'vue-router'
import vue404 from '@/page/404.vue'
import Login from '@/page/pc/Login.vue'
import MyCourseList from '@/page/pc/myCourse/MyCourseList.vue'
import VideoPlay from '@/page/pc/videoPlay/PcVideoPlay.vue'
import CourseDetail from '@/page/pc/CourseDetail'
// 答题卡
import AnswerView from '@/page/pc/AnswerView/AnswerView'
// 答题解析
import ParsingView from '@/page/pc/AnswerView/ParsingView'
import Result from '@/page/pc/question/Result.vue'
//错题
import WarningView from '@/page/pc/AnswerView/WarningView.vue'
//收藏
import BankKeep from '@/page/pc/AnswerView/BankKeep.vue'
// h5路由
import LoginMobile from '@/page/h5/Login.vue'
import MyCourseListMobile from '@/page/h5/MyCourseList.vue'
import CourseDetailMobile from '@/page/h5/CourseDetail.vue'
import AnswerPage from '@/page/h5/AnswerPage.vue'
import StartTestMobile from '@/page/h5/StartTest.vue'
import WarningAndCollectPage from '@/page/h5/WarningAndCollectPage.vue'
import CollectionFinished from '@/page/h5/CollectionFinished.vue'
import ResultPage from '@/page/h5/ResultPage.vue'
import ParsingPage from '@/page/h5/ParsingPage.vue'
import VideoPlayMobile from '@/page/h5/VideoPlay.vue'
Vue.use(Router)
const router = new Router({
  // mode: 'history',
  // base: process.env.VUE_APP_BASE_URL,
  routes: [{
      path: '/h5/videoPlay',
      name: 'VideoPlayMobile',
      meta: {
        title: '视频播放'
      },
      component: VideoPlayMobile
    },
    {
      path: '/h5/ParsingPage',
      name: 'ParsingPage',
      meta: {
        title: '解析卡'
      },
      component: ParsingPage
    },
    {
      path: '/h5/resultPage',
      name: 'ResultPage',
      meta: {
        title: '结果页'
      },
      component: ResultPage
    },
    {
      path: '/h5/CollectionFinished',
      name: 'CollectionFinished',
      meta: {
        title: '收藏看完结果页'
      },
      component: CollectionFinished
    },
    {
      path: '/h5/warningPage',
      name: 'WarningAndCollectPage',
      meta: {
        title: '错题卡'
      },
      component: WarningAndCollectPage
    },
    {
      path: '/h5/StartTest', // 默认进入路由
      name: 'StartTestMobile',
      meta: {
        title: '开始测试'
      },
      component: StartTestMobile
    },
    {
      path: '/h5/AnswerPage',
      name: 'AnswerPage',
      meta: {
        title: '答题卡'
      },
      component: AnswerPage
    },
    {
      path: '/h5/CourseDetail', // 默认进入路由
      name: 'CourseDetailMobile',
      meta: {
        title: '课程列表'
      },
      component: CourseDetailMobile
    },
    {
      path: '/h5/myCourseList', // 默认进入路由
      name: 'MyCourseListMobile',
      meta: {
        title: '我的课程'
      },
      component: MyCourseListMobile
    },
    {
      path: '/pc/WarningView', // 错题
      name: 'WarningView',
      meta: {
        title: '错题页面'
      },
      component: WarningView
    },
    {
      path: '/h5/Login', // 默认进入路由
      name: 'LoginMobile',
      alias: '/h5/Login',
      meta: {
        title: '学员登录'
      },
      component: LoginMobile
    },
    {
      path: '/pc/BankKeep', // 试题
      name: 'BankKeep',
      meta: {
        title: '试题收藏'
      },
      component: BankKeep
    },
    {
      path: '/', // 默认进入路由
      name: 'home',
      alias: '/pc/Login',
      meta: {
        title: '学员登录'
      },
      component: Login
    },
    {
      path: '/pc/MyCourseList', // 默认进入pc课程主页列表
      name: 'MyCourseList',
      meta: {
        title: '我的课程'
      },
      component: MyCourseList
    },
    {
      path: '/pc/AnswerView',
      name: 'AnswerView',
      meta: {
        title: '答题'
      },
      component: AnswerView
    },
    {
      path: '/pc/ParsingView',
      name: 'ParsingView',
      meta: {
        title: '解析'
      },
      component: ParsingView
    },
    {
      path: '/pc/VideoPlay', // 默认进入路由
      name: 'VideoPlay',
      meta: {
        title: '视频播放'
      },
      component: VideoPlay
    },
    {
      path: '/pc/CourseDetail',
      name: 'CourseDetail',
      meta: {
        title: '课程列表'
      },
      component: CourseDetail
    },
    {
      path: '/pc/Result',
      name: 'Result',
      meta: {
        title: '答题结果'
      },
      component: Result
    },
    {
      path: '/404',
      name: 'notFound',
      meta: {
        title: '404未找到'
      },
      component: vue404
    },
    {
      path: '*',
      name: 'notFound',
      meta: {
        title: '404未找到'
      },
      component: vue404
    }
  ]
})
export default router
